import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=5b589c87&scoped=true&"
import script from "./Message.vue?vue&type=script&lang=js&"
export * from "./Message.vue?vue&type=script&lang=js&"
import style0 from "./Message.vue?vue&type=style&index=0&id=5b589c87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b589c87",
  null
  
)

export default component.exports